// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MemberNumberDetails {
    static getAttributeTypeMap() {
        return MemberNumberDetails.attributeTypeMap;
    }
}
MemberNumberDetails.discriminator = undefined;
MemberNumberDetails.attributeTypeMap = [
    {
        "name": "bin",
        "baseName": "bin",
        "type": "string"
    },
    {
        "name": "groupNumber",
        "baseName": "groupNumber",
        "type": "string"
    },
    {
        "name": "pcn",
        "baseName": "pcn",
        "type": "string"
    }
];
//# sourceMappingURL=memberNumberDetails.js.map